import React, { Component } from 'react';
import {Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader} from "antd";
import Simple from './Table';
import { connect } from "react-redux";
import getDate from 'util/ConfigDates'
import{
    fetchNotifications
} from "appRedux/actions/Notifications";

class Notifications extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),

    }
  }
  componentDidMount() {
    this.props.fetchNotifications();
    //this.props.fetchNotifications(this.state);
  }


  render ( ) {
    return (
        <Simple/>
    );
  }
}

export default connect(null, { fetchNotifications })(Notifications);



// WEBPACK FOOTER //
// ./src/routes/main/Notification/index.js